import React, { useState, useEffect } from 'react';
import { collection, query, onSnapshot, doc, updateDoc, getDocs, where, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import productionCostService from '../../services/productionCostService';

const MaterialPurchaseOrder = () => {
  const { userData } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [suppliers, setSuppliers] = useState([]);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [selectedProductionOrder, setSelectedProductionOrder] = useState(null);

  useEffect(() => {
    if (!userData?.companyId) return;

    // Fetch Production Orders
    const q = query(collection(db, 'companies', userData.companyId, 'productionOrders'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const ordersData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setOrders(ordersData);
      setLoading(false);
    });

    // Fetch Suppliers
    const sQuery = query(collection(db, 'companies', userData.companyId, 'suppliers'));
    getDocs(sQuery).then(snapshot => {
      setSuppliers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    return () => unsubscribe();
  }, [userData?.companyId]);

  const handleCreateOrder = async (pOrder, material, supplierId) => {
    if (!userData?.companyId) return;

    const supplier = suppliers.find(s => s.id === supplierId);
    if (!supplier) return alert("Lütfen tedarikçi seçiniz");

    try {
      // 1. Create a purchase order document (optional, but good for tracking)
      const purchaseRef = await addDoc(collection(db, 'companies', userData.companyId, 'materialPurchaseOrders'), {
        productionOrderId: pOrder.id,
        productionOrderName: pOrder.product,
        materialName: material.name,
        quantity: material.quantity,
        unit: material.unit,
        supplierId: supplier.id,
        supplierName: supplier.name,
        status: 'Sipariş Verildi',
        createdAt: serverTimestamp()
      });

      // 2. Update production order status if needed
      // ...

      alert(`${material.name} için ${supplier.name} tedarikçisine sipariş oluşturuldu.`);
    } catch (err) {
      console.error("Error creating material order:", err);
      alert("Hata: " + err.message);
    }
  };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Yükleniyor...</div>;

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto', fontFamily: '"Inter", sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
        <div>
          <h1 style={{ fontSize: '28px', fontWeight: '800', color: '#1a1d29', margin: 0 }}>Malzeme Sipariş Yönetimi</h1>
          <p style={{ color: '#64748b', marginTop: '4px' }}>Üretim emirleri için gereken hammadde ve kumaş tedarik süreci</p>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '24px' }}>
        {orders.filter(o => o.status !== 'completed').map(order => (
          <div key={order.id} style={{
            background: 'white',
            borderRadius: '16px',
            padding: '24px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            border: '1px solid #e2e8f0'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
               <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700' }}>{order.product}</h3>
               <span style={{ fontSize: '12px', color: '#94a3b8' }}>#{order.id.substring(0, 8).toUpperCase()}</span>
            </div>

            <div style={{ marginBottom: '20px' }}>
               <div style={{ fontSize: '13px', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>Hammadde İhtiyacı:</div>
               {order.rawMaterials?.map((rm, idx) => (
                 <div key={idx} style={{ 
                   display: 'flex', 
                   justifyContent: 'space-between', 
                   alignItems: 'center',
                   padding: '10px',
                   background: '#f8fafc',
                   borderRadius: '8px',
                   marginBottom: '8px'
                 }}>
                   <div>
                     <div style={{ fontSize: '14px', fontWeight: '600' }}>{rm.name}</div>
                     <div style={{ fontSize: '12px', color: '#64748b' }}>{rm.quantity} {rm.unit} gerekli</div>
                   </div>
                   <button 
                     style={{
                       padding: '6px 12px',
                       borderRadius: '6px',
                       border: '1px solid #06C167',
                       background: 'transparent',
                       color: '#06C167',
                       fontSize: '12px',
                       fontWeight: '600',
                       cursor: 'pointer'
                     }}
                   >
                     Sipariş Ver
                   </button>
                 </div>
               ))}
            </div>

            <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: '15px', fontSize: '13px', color: '#64748b' }}>
               <strong>Üretim Tarihi:</strong> {new Date(order.plannedDate).toLocaleDateString('tr-TR')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MaterialPurchaseOrder;
